import Card from "../ui/Card";
import PropTypes from "prop-types";

const SystemInfo = ({ profile, darkMode, t }) => {
  return (
    <Card variant="system" darkMode={darkMode}>
      <h3>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          style={{
            display: "inline-block",
            verticalAlign: "middle",
            marginRight: "12px",
            color: "var(--accent-green)",
          }}
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="9" y1="3" x2="9" y2="21" />
        </svg>
        {t("System Information")}
      </h3>

      <div className="system-info-grid">
        <div className="system-info-item">
          <div className="system-info-label">{t("User ID")}</div>
          <div className="system-info-value">
            {profile?.user_id || profile?.id || "—"}
          </div>
        </div>

        <div className="system-info-item">
          <div className="system-info-label">{t("Database ID")}</div>
          <div className="system-info-value">{profile?.id || "—"}</div>
        </div>

        <div className="system-info-item">
          <div className="system-info-label">{t("Active Status")}</div>
          <div className="system-info-value">
            <span
              className={
                profile?.is_active ? "status-active" : "status-inactive"
              }
            >
              {profile?.is_active ? (
                <>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                      marginRight: "6px",
                    }}
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  {t("Active")}
                </>
              ) : (
                <>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                      marginRight: "6px",
                    }}
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                  {t("Inactive")}
                </>
              )}
            </span>
          </div>
        </div>
      </div>
    </Card>
  );
};

SystemInfo.propTypes = {
  profile: PropTypes.object,
  darkMode: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default SystemInfo;
